/**
 * Two-point linear interpolation.
 *
 * The cheapest thing that works, and what the pump shipped with. Its weakness is
 * a low-pass tilt that worsens as the fractional position approaches the middle
 * of a sample interval — audible as dullness on material that has been
 * upsampled a long way, which is exactly the 8 kHz case.
 *
 * Kernels take a small window the processor has already assembled and clamped,
 * so they are plain functions over plain arrays: directly testable in Node, and
 * self-contained enough to be serialised into the worklet.
 *
 * @param {Float32Array} w - window of samples
 * @param {number} i - index within `w` of the sample at floor(position)
 * @param {number} mu - fractional position within [0, 1)
 */
export function readLinear(w, i, mu) {
  const a = w[i];
  return a + (w[i + 1] - a) * mu;
}

export const LINEAR = {
  id: "linear",
  label: "Linear",
  kernel: "linear",
  taps: 2,
  before: 0,
  after: 1,
  notes: "Cheapest. Noticeably dull on heavily upsampled material.",
  buildTable: () => null,
  params: { taps: 2 },
};
